import styles from './ExamChangeVisualization.module.scss'
import React, { ReactElement, useCallback, useMemo, useState } from 'react'
import { ExamChangeVisualizationProps } from '@/components/ExamChangeGuidePage/ExamChangeVisualization/ExamChangeVisualization.types'
import { SourceType } from '@/components/ExamChangeGuidePage/ExamChangeGuidePage.types'
import CheckboxGroup, { CheckboxValueType } from 'antd/lib/checkbox/Group'
import { ExamChangeTable } from '@/components/ExamChangeGuidePage/ExamChangeVisualization/ExamChangeTable/ExamChangeTable'

export const ExamChangeVisualization: React.FC<
    ExamChangeVisualizationProps
> = (): ReactElement => {
    const [checkedList, setCheckedList] = useState<CheckboxValueType[]>(
        Object.keys(SourceType)
    )
    const options = useMemo(
        (): { label: string; value: string }[] =>
            Object.entries(SourceType).map(([sourceValue, sourceKey]) => ({
                label: sourceKey,
                value: sourceValue,
            })),
        []
    )

    const onChange = useCallback((list: CheckboxValueType[]) => {
        setCheckedList(list)
    }, [])

    return (
        <>
            <div className={styles.examChangeVisualizationContainer}>
                <ExamChangeTable
                    includeSourceTypes={checkedList as SourceType[]}
                />
                <div className={styles.checkboxesContainer}>
                    <div className={styles.checkboxesTitle}>Source Types</div>
                    <div>
                        <CheckboxGroup
                            options={options}
                            value={checkedList}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.examChangeVisualizationCaption}>
                Above you can see:
                <ol>
                    <li>The new GHDP is largely made up of the old GHDP.</li>
                    <li>
                        The new GHVR-US is largely made up of the old GHFV-US
                        with roughly half the sections of old GHFV-US removed.
                    </li>
                    <li>
                        The new GHRM is a mix of the old GHDP and GHSPC (with
                        roughly half the sections of the old GHSPC removed).
                    </li>
                </ol>
            </div>
        </>
    )
}
